import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { CommonDropDown } from 'src/app/common/types/dropdown.type';
import { MaterialModule } from 'src/app/material.module';
import { LookupService } from 'src/app/services/lookup.service';
import { ClinicalSubCategoryService } from '../clicnical-sub-category.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IClinicalSubCategory } from '../iclinical-sub-category';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-hospital',
  standalone: true,
  imports: [
    MaterialModule,
    ReactiveFormsModule,
    CommonModule,
    MatInputModule,
    TranslateModule
  ],
  templateUrl: './clinical-sub-category-detail.component.html',
})
export class ClinicalSubCategoryDetailsComponent implements OnInit {

  categoryList: CommonDropDown[];// category dropdown
  subCategoryForm: FormGroup;
  isEdit: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _formBuilder: FormBuilder,
    private _lookupService: LookupService,
    private _subcategoryService: ClinicalSubCategoryService,
    private toastr: ToastrService,
    private translationUtils: TranslationUtils,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<ClinicalSubCategoryDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: { subcategory: IClinicalSubCategory, isEdit: boolean, categoryId: number, subcategoryValueFromItem: string },
    @Inject(MAT_DIALOG_DATA) private category: { categoryvalue: CommonDropDown },

  ) {
    this.isEdit = _data?.isEdit;
  }

  ngOnInit(): void {
    this.subCategoryForm = this._formBuilder.group({
      name: [this._data?.subcategory?.name || this._data?.subcategoryValueFromItem, [Validators.required, Validators.maxLength(100)]],
      categoryId: [this.category?.categoryvalue?.id || this._data?.subcategory?.categoryId || this._data?.categoryId, [Validators.required]],
      description: [this._data?.subcategory?.description, [Validators.maxLength(255)]],
      seqno: [1]
    })

    if (this.category?.categoryvalue?.id || this._data?.subcategory?.categoryId) {
      this.subCategoryForm.get('categoryId')?.disable();
    } else {
      this.subCategoryForm.get('categoryId')?.enable();
    }
    this._lookupService.clinicalcategories$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((category: CommonDropDown[]) => {
        this.categoryList = category;
      });
  }

  onSubcategorySave() {
    const subcategory = this.subCategoryForm.getRawValue();
    this._subcategoryService.createSubcategory(subcategory).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.SUBCATEGORY')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });

  }

  onSubcategoryUpdate() {
    const subcategory =
    {
      ...this.subCategoryForm.getRawValue(),
      id: this._data?.subcategory?.id
    };

    this._subcategoryService.updateSubcategory(subcategory).subscribe({
      next: (response) => {
        if (response.isSuccess) {
          this.dialogRef.close(response);
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.SUBCATEGORY')));
        }
      },
      error: (error) => {
        if (error?.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat();
          this.toastr.error(allErrors.join("\n"));
        } else {
          this.toastr.error('Something went wrong');
        }
      }
    });

  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}



